<template>
  <div class="offline-tail-money-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="isFullPayment && !isWechatBrowser" title="支付全款" :showBack="true"></my-header>
    <my-header v-if="!isFullPayment && !isWechatBrowser" title="支付尾款" :showBack="true"></my-header>
    <div class="offline-tail-money-form">
      <div class="input-group">
        <div class="input-label">收款商户</div>
        <input class="mint-field-core form-input" v-model="shopName" readonly="readonly">
      </div>
      <div class="input-group">
        <div class="input-label">联系人</div>
        <input class="mint-field-core form-input" type="text" v-model="name" placeholder="请输入联系人姓名">
      </div>
      <div class="input-group">
        <div class="input-label">联系电话</div>
        <input class="mint-field-core form-input" type="number" v-model="phone" placeholder="请输入联系电话">
      </div>
      <div class="input-group">
        <div class="input-label">收货地址</div>
        <input class="mint-field-core form-input" type="text" v-model="receiveAddress" placeholder="请输入收货地址">

      </div>
      <div class="input-group">
        <div class="input-label">送货期限</div>
        <input class="mint-field-core form-input" readonly="readonly" @click="open('endTimePicker')" v-model="deliverLimit" placeholder="请选择送货期限">
        <mt-datetime-picker ref="endTimePicker" @confirm="setDeliverLimitTime" v-model="deliverLimitTime" type="date" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日">
        </mt-datetime-picker>
      </div>
      <div class="input-group">
        <div class="input-label">总金额</div>
        <input class="mint-field-core form-input" type="number" v-model="amountMoney"  placeholder="请输入订单总金额">
      </div>
      <div class="input-group">
        <div class="input-label">买家留言</div>
        <input class="mint-field-core form-input" type="text" v-model="message" placeholder="请输入您对商家留言">
      </div>
      <div class="input-group">
        <div class="input-label">备注</div>
        <input class="mint-field-core form-input" type="text" v-model="remarks" placeholder="订单备注">
      </div>
      <div class="evaluate">
        <span class="evaluate-field">交易评分</span>
        <span @click="selectEvaluateScore('1')">
          <img v-if="evaluateScore == '1'" class="icon-select" src="../../assets/icon/icon-selected.png">
          <img v-if="evaluateScore == '2'" class="icon-select" src="../../assets/icon/icon-unselected.png">
          <span>满意</span></span>
        <span @click="selectEvaluateScore('2')" class="evaluate-bad">
          <img v-if="evaluateScore == '1'" class="icon-select" src="../../assets/icon/icon-unselected.png">
          <img v-if="evaluateScore == '2'" class="icon-select" src="../../assets/icon/icon-selected.png">
          <span>不满意</span></span>
      </div>
      <div class="input-group">
        <div class="input-label">交易评价</div>
        <input class="mint-field-core form-input" type="text" v-model="evaluateContent" placeholder="请写下你对本次交易的评价">
      </div>
      <div class="record-img border-top-style">
        <div class="image-area">
          <div class="image-view">
            <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
              <div class="image" :data-index="index" style="position: relative">
                <img :src="imgUrl+recoredImg" @click.stop="optionImage(index,$event)">
              </div>
            </div>
            <div>
              <div class="image add-image" @click.stop="addImage()">
                <span class="icon-plus"><img src="../../assets/icon/icon-plus.png"></span>
                <span style="display: none;"><input type="file" id="image-input" multiple accept="image/*"></span>
              </div>
              <div>上传凭证</div>
            </div>
          </div>
        </div>
      </div>
      <div class="trade-amount-info">
        <div class="amount-info-item">
          <div>订金总金额</div><div class="amount-info-value">¥{{amountMoney}}</div>
        </div>
        <div class="amount-info-item">
          <div>订金抵扣</div><div class="amount-info-value">¥{{deposit}}</div>
        </div>
        <div class="payable-amount border-top-style">实际应付金额 : <span class="amount-info-value">¥{{amount}}</span></div>
      </div>
      <div class="form-btn" @click="payTraderOffline" v-if="!isPay">提交并支付</div>
      <div class="form-btn" v-if="isPay" @click="toTradeOfflineList">去查看支付结果</div>
    </div>
  </div>
</template>

<script>
  import {Indicator,Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import baseService from '../../service/BaseService';
  import lrz from 'lrz';
  import {imgUrl} from "../../config";
  import payUtil from '../../utils/Pay'
  import tradeOfflineService from '../../service/trade/TradeOfflineService'
  import customerAddressService from '../../service/customer/CustomerAddressService'
  import dealerShopService from '../../service/shop/ShopService'

  export default {
    name: 'OfflineTailMoney',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        errorMsg:'',
        prePayInfo:{},
        isFullPayment:true,
        imgUrl:imgUrl,
        shopId:'',
        activityId:'',
        type:'3',
        activity:{},
        tradeOffline:{},
        shopName:'',
        promotionList:[],
        name:'',
        phone:'',
        receiveAddress:'',
        amountMoney:'',
        amount:0,
        deposit:0,
        message:'',
        remarks:'',
        addressId:'',
        deliverLimit:'',
        deliverLimitTime:new Date(),
        evaluateScore:'1',
        evaluateContent:'',
        attachmentUrlList:[],
        attachmentIds:'',
        tradeOfflineId:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isPay:false,
      }
    },
    created(){
      document.title = this.$route.meta.title;
      this.shopName = this.$route.query.shopName;
      this.tradeOfflineId = this.$route.query.tradeOfflineId || '';

      this.shopId = this.$route.query.shopId;
      this.activityId = this.$route.query.activityId;
      this.type = this.$route.query.type;
    },
    beforeMount () {
      this.getCustomerDefaultAddress();
      if(this.shopId){
        this.getShopPromotionList();
      }
      if(this.tradeOfflineId){
        this.isFullPayment = false;
        this.getTradeOfflineDetail();
      }
      //增加Date对象方法
      Date.prototype.format = function (fmt) { //author: meizz
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "H+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
      }
    },
    watch:{
      amountMoney(value){
        this.amount = value - this.deposit;
      }
    },
    methods: {
      async getCustomerDefaultAddress(){
        let {code,msg,data} = await customerAddressService.getDefault();
        if(code == '0'){
          this.addressId = data.id;
          this.name = data.receiver;
          this.phone = data.phone;
          this.receiveAddress = data.address;
        }else {
          Toast(msg);
        }
      },
      async getShopPromotionList(){
        let {code,msg,data} = await dealerShopService.promotionList(this.shopId,this.activityId);
        if(code == '0'){
          this.shopName = data.shop.name;
          this.activity = data.activity || {discount:0};
          this.discount = this.activity.discount;
          this.promotionList = data.promotions;
        }else {
          Toast(msg);
        }
      },
      async getTradeOfflineDetail(){
        let {code,msg,data} = await tradeOfflineService.detail(this.tradeOfflineId);
        if(code == '0'){
          this.tradeOffline = data.offline;
          this.type = this.tradeOffline.type;
          this.deposit = this.tradeOffline.payMoney;
          this.shopId = this.tradeOffline.shopId;
        }else {
          Toast(msg);
        }
      },
      open(picker) {
        this.$refs[picker].open();
      },
      setDeliverLimitTime(value) {
        this.deliverLimit = value.format("yyyy-MM-dd");
      },
      selectEvaluateScore(score){
        this.evaluateScore = score;
      },
      async payTraderOffline(){
        if(!this.name){
          Toast('请输入联系人姓名');
          return false;
        }
        if(!this.phone){
          Toast('请输入联系电话');
          return false;
        }
        let re= /^1[3578]\d{9}$/;
        if(!re.test(this.phone)){
          Toast('您输入的手机号码有误,请重新输入!');
          return false;
        }
        if(!this.receiveAddress){
          Toast('请输入收货地址');
          return false;
        }
        var reg = /^(([1-9]\d*)|0)(\.\d{1,2})?$/;
        if(!this.amountMoney){
          Toast('请输入订单总金额');
          return false;
        }else if(!reg.test(this.amountMoney)){
          Toast('请输入正确的订单总金额');
          return false;
        }

        if(this.deposit && this.amountMoney <= this.deposit){
          Toast('总金额必须大于抵扣金额');
          return false;
        }

        if(!this.attachmentIds && !this.isFullPayment){
          Toast('请上传支付凭证');
          return false;
        }
        this.attachmentIds = this.attachmentIds.substring(1,this.attachmentIds.length);
        let tradeOfflineFormData = {tradeOfflineId:this.tradeOfflineId,offlineType:this.type,shopId:this.shopId,amount:this.amountMoney,name:this.name,phone:this.phone,receiveAddress:this.receiveAddress,attachmentIds:this.attachmentIds,
          addressId:this.addressId,message:this.message,remarks:this.remarks,deliverLimit:this.deliverLimit,evaluateScore:this.evaluateScore,evaluateContent:this.evaluateContent};

        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          tradeOfflineFormData.browserType = '1';
          let result = await tradeOfflineService.saveAndPayOrder(tradeOfflineFormData);
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          tradeOfflineFormData.browserType = '2';
          let result = await tradeOfflineService.saveAndPayOrder(tradeOfflineFormData);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mwebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.isPay = true;
                that.$router.push({name:'TradeOfflineList'});
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res);
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      //上传图片
      async addImage(){
        //判断是app还是浏览器访问
        var sUserAgent=navigator.userAgent;
        if(sUserAgent.endsWith("jikeWeb")){
          this.actions = [{
            name: '拍照',
            method: this.openCamera
          }, {
            name: '从相册中选择',
            method: this.selectImage
          }];
          this.sheetVisible = true;
        }else{
          //使用input文件选择
          var fileInput = document.querySelector("#image-input");
          fileInput.click();
          var that = this;
          fileInput.onchange = function(){
            var file = this.files[0];
            if(this.outerHTML){
              this.outerHTML=this.outerHTML;
            }else{      //FF
              this.value="";
            }
            Indicator.open({
              text: '加载中...',
              spinnerType: 'fading-circle'
            });
            lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
              return baseService.uploadImage(file);
            }).then((file) => {
              //处理image,key
              that.attachmentIds = that.attachmentIds + ',' +file.id;
              that.attachmentUrlList.push(file.name);
            }).catch((err) =>{
              console.log("上传文件失败========",err);
            }).always(()=>{
              Indicator.close();
            });
          }
        }
      },
      optionImage(categoryIndex,nodeIndex,index,event){
        var that = this;
        this.actions = [
//          {
//          name: '查看',
//          method: () =>{
//            this.previewImage(categoryIndex,nodeIndex,index,event);
//          }
//        },
          {
            name: '删除',
            method: () =>{this.deleteImageFromList(index);}
      }];
        this.sheetVisible = true;
      },
      deleteImageFromList(index){

      },
      toTradeOfflineList(){
        this.$router.push({name:'TradeOfflineList'});
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .picker-slot{
    font-size: 0.32rem;
  }
  .offline-tail-money-page {
    background: white;
    padding-bottom: 0.8rem;
    color: #1B1E29;
    font-size: 0.32rem;
    text-align: left;
    .offline-tail-money-form{
      .input-group{
        padding-top: 0.2rem;
      }
    }
    .evaluate{
      height: 0.9rem;
      line-height: 0.9rem;
      width: 6.9rem;
      padding-top: 0.27rem;
      margin: 0rem auto;
    }
    .evaluate-field{
      margin-right: 0.32rem;
    }
    .icon-select{
      width: 0.37rem;
      height: 0.39rem;
      position: relative;
      top: 0.1rem;
      margin-right: 0.2rem;
    }
    .evaluate-bad{
      padding-left: 0.4rem;
   }
  .record-img{
    margin-top: 0.28rem;
  }
  .image-area{
    background-color: #fff;
    width: 100%;
    .image-view{
      display: flex;
      flex-flow: row wrap;
      padding:0.3rem 14px;
      padding-right:0px;
      .image{
        width:1.64rem;
        height: 1.64rem;
        background: #F3F8FC;
        margin-bottom: 5px;
        margin-right:14px;
        &.add-image{
           display: flex;
           flex-flow: row wrap;
           justify-content: center;
           align-items: center;
           color: #999;
         }
        .icon-plus img{
          width: 0.8rem;
          height: 0.8rem;
          position: relative;
        }
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .image-tip{
      padding:10px;
      font-size: 14px;
      color: #999999;
    }
  }
  }
</style>
